// Helpers for `responseType: 'blob'` downloads.

// The server names the pre-employment report file — employee name plus the appointment its
// reports were collected from — so read that name rather than rebuilding the rule here, where it
// would drift the first time the backend changes it. Depends on the API exposing
// Content-Disposition through CORS; falls back to the caller's name when it is unreadable.
export const filenameFromResponse = (response, fallback) => {
  const header = response && response.headers && response.headers['content-disposition'];
  if (!header) return fallback;

  const encoded = header.match(/filename\*=UTF-8''([^;]+)/i);
  if (encoded) {
    try {
      return decodeURIComponent(encoded[1].trim());
    } catch (e) {
      // malformed encoding — fall through to the plain filename
    }
  }

  const plain = header.match(/filename="([^"]+)"/i);
  return plain ? plain[1] : fallback;
};

// On a blob request axios hands back the error body as a Blob, so the usual
// `error.response.data.msg` is undefined and every failure reads as "something went wrong".
// Read it back as text so the server's own message reaches the user.
export const blobErrorMessage = async (error, fallback) => {
  const body = error && error.response && error.response.data;
  if (!body) return fallback;

  try {
    const text = typeof body.text === 'function' ? await body.text() : body;
    const parsed = typeof text === 'string' ? JSON.parse(text) : text;
    return (parsed && parsed.msg) || fallback;
  } catch (e) {
    return fallback;
  }
};
